'use client';

import { useEffect } from 'react';
import { useScrollLock } from 'usehooks-ts';

export const useConditionalScrollLock = (shouldLock: boolean) => {
    const { lock, unlock } = useScrollLock({ autoLock: false });

    useEffect(() => {
        if (!shouldLock) return;

        lock();

        return () => {
            unlock();
        };
    }, [lock, unlock, shouldLock]);
};
